import { LoadingButton } from '@mui/lab';
import { Button, DialogTitle, CardContent, Link, ListItemIcon, Paper, Box, useMediaQuery } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ErrorIcon from '@mui/icons-material/Error';

const InstagramDirectAuthorizationModal = (props) => {
  const { t: translate } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [isLoadingOn, setLoadingOn] = useState(false);

  const handleConnectInstagram = () => {
    setLoadingOn(true);
    props.handleConnectInstagram();
  };

  const handleClose = () => {
    props.handleClose();
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open>
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography gutterBottom variant="h4">
            {props.reAuth
              ? translate('instagram_auth_dialog.title_reconnect')
              : translate('instagram_auth_dialog.title_connect')}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <CardContent sx={{ p: { xs: 0, md: 0 }, color: 'grey.800', typography: 'body1' }}>
          <Typography variant="body1" sx={{ margin: 'auto 0', fontWeight: 'bold' }}>
            {props.reAuth
              ? translate('instagram_auth_dialog.requirements_reconnect')
              : translate('instagram_auth_dialog.requirements_connect')}
          </Typography>

          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1, mt: 2 }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
            </ListItemIcon>
            <Typography variant="body1">
              {translate('instagram_auth_dialog.account_active')}
            </Typography>
          </Paper>
          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
            </ListItemIcon>
            <Typography variant="body1">
              {translate('instagram_auth_dialog.correct_credentials')}
            </Typography>
          </Paper>
          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
            <ListItemIcon>
              <ErrorIcon sx={{ color: 'success.dark', width: 20, height: 20, ml: 2, mt: 0.5 }} />
            </ListItemIcon>
            <Typography variant="body1">
              {translate('instagram_auth_dialog.analytics_note')}
            </Typography>
          </Paper>
        </CardContent>
      </DialogContent>
      <DialogActions>
        <Button color="error" variant="outlined" onClick={handleClose}>
          {translate('instagram_auth_dialog.cancel_button')}
        </Button>
        <LoadingButton
          variant="contained"
          loading={isLoadingOn}
          autoFocus
          onClick={handleConnectInstagram}
        >
          {props.reAuth
            ? translate('instagram_auth_dialog.reconnect_button')
            : translate('instagram_auth_dialog.connect_button')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default InstagramDirectAuthorizationModal;